import React from 'react';
import { LabelWithLoading } from './LabelWithLoading';
import { useGlobalization } from '@Translations/useGlobalization';
import { ratingCell } from '@Utils/inspections.utills';
import { useDateFormatter } from './useDateFormatter';
import { PopupDetails } from './types';

const isInspectionType = (type: string, version: string | undefined) =>
	version?.startsWith(type);

export const ExtendedDetails: React.VFC<{
	popupDetails: PopupDetails;
	isLoading: boolean;
	areInspectionsLoading: boolean;
}> = ({ popupDetails, isLoading, areInspectionsLoading }) => {
	const { t } = useGlobalization();
	const formatDate = useDateFormatter();

	return (
		<>
			<LabelWithLoading
				label={t('Inspection Date')}
				value={formatDate(popupDetails?.lastInpsectionDate)}
				loading={areInspectionsLoading}
			/>
			{!['MSCC', 'WSA'].some(type =>
				isInspectionType(type, popupDetails?.popupInspectionVersion),
			) && (
				<LabelWithLoading
					label={t('Quick Rating')}
					value={
						(popupDetails?.quickRating &&
							ratingCell(popupDetails.quickRating, t)) ??
						' - '
					}
					loading={areInspectionsLoading}
				/>
			)}
			{['MSCC', 'WSA'].some(type =>
				isInspectionType(type, popupDetails?.popupInspectionVersion),
			) && (
				<LabelWithLoading
					label={t('Service Grade')}
					value={popupDetails?.popupServiceGradeRating ?? ' - '}
					loading={isLoading}
				/>
			)}
			{isInspectionType('WSA', popupDetails?.popupInspectionVersion) && (
				<LabelWithLoading
					label={t('Structural Grade')}
					value={popupDetails?.popupStructuralGradeRating ?? ' - '}
					loading={isLoading}
				/>
			)}
		</>
	);
};
